import { getEnv } from 'configs/env';
import { Button, CreateAlert, Icon, NumberUtils, Table } from 'modules';
import moment from 'moment';
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as XLSX from 'xlsx';

import {
  TableFilterInputText,
  TableFilterRangeTimeInput,
} from '../../../components/table-filter-inputs';
import { getLocaleKey, translate } from '../../../languages';
import { AdminService } from '../../../services/admin';
import { withFranchiseWraper } from '../wraper';
type Props = {};

const CopyToClipboardElement = CopyToClipboard as any;

const PageFranchiseCommissionHistory = withFranchiseWraper((props: Props) => {
  const [currentData, setCurrentData] = useState(null as any);
  const [totalAmount, setTotalAmount] = useState<any>();
  const [params, setParams] = useState<any>();

  // const startOfMonth = moment().subtract(1, "week").startOf("week");
  const startOfMonth = moment().startOf('week').add(1, 'day');
  const endOfDay = moment().endOf('day');

  return (
    <div className='franchise-commission-history'>
      <div className='button-container'>
        <Button
          disabled={!currentData}
          label='Export to Excel'
          buttonType='success'
          className='mb15'
          onClick={async () => {
            const response =
              await AdminService.getListCommissionHistoryFranchise({
                ...params,
                page: 1,
                numberOfTransactionsPerPage: 100000,
              });
            const data = [
              [
                'User',
                'Level',
                'Type',
                'Amount',
                'User (user-generated)',
                'Level (user-generated)',
                'Personal Volume (user-generated)',
                'Created',
              ],
              ...response.data.map((item: any) => {
                const row: any[] = [];

                row.push(item?.userFirstName + '\n' + item?.userEmail);
                row.push(item.userRank);
                row.push(item.transactionTypeName);
                row.push(
                  // item?.userAmount
                  //   ? NumberUtils.toFormatNumber(
                  //       +item?.userAmount,
                  //       +getEnv("NUMBER_DECIMAL_DISPLAY")
                  //     )
                  //   : `0.00000000`
                  item?.userAmount || 0.0,
                );
                row.push(
                  item?.userGeneratedFirstName +
                    '\n' +
                    item?.userGeneratedEmail,
                );
                row.push(item.userGeneratedRank);
                row.push(
                  // item?.userGeneratedVolume
                  //   ? NumberUtils.toFormatNumber(
                  //       +item?.userGeneratedVolume,
                  //       +getEnv("NUMBER_DECIMAL_DISPLAY")
                  //     )
                  //   : `0.00000000`
                  item?.userGeneratedVolume || 0.0,
                );
                row.push(moment(item?.created).format('YYYY/MM/DD HH:mm'));

                return row;
              }),
            ];

            const ws = XLSX.utils.aoa_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');

            const now = new Date();
            XLSX.writeFile(
              wb,
              `Commission-History-${now.toLocaleDateString().replace(/\//g, '-')} ${now
                .toLocaleTimeString()
                .replace(/:/g, '-')}.xlsx`,
              { type: 'binary' },
            );
          }}
        />
        <div className='infor-container'>
          <div className='total-amount'>
            <div className='total-amount__icon'>
              <Icon.TotalPackageIcon />
            </div>
            <div className='total-amount__content'>
              ${new Intl.NumberFormat('en').format(totalAmount ?? 0)}
              <span className='sub-text'>&nbsp;TOTAL AMOUNT</span>
            </div>
          </div>
        </div>
      </div>

      <Table
        hasOrderColumn
        className='overload'
        filters={[
          {
            name: 'User',
            key: 'queryInput',
            input: TableFilterInputText,
          },
          {
            name: translate('time'),
            key: 'created',
            input: (e) => (
              <TableFilterRangeTimeInput
                {...e}
                fromKey='fromDate'
                toKey='toDate'
              />
            ),
            defaultValue: {
              fromDate: startOfMonth,
              toDate: endOfDay,
            },
          },
        ]}
        structure={[
          {
            name: 'User',
            key: 'userEmail',
            render: (item) => {
              return (
                <>
                  <span>{item?.userFirstName}</span>
                  <br />
                  <span>
                    <CopyToClipboardElement
                      text={item?.userEmail}
                      onCopy={() => {
                        CreateAlert({
                          message: translate('Copied'),
                          type: 'success',
                        });
                      }}
                    >
                      <div className='value'>
                        <span className='email'>{item?.userEmail}</span>
                        <span className='icon'>
                          <Icon.Copy />
                        </span>
                      </div>
                    </CopyToClipboardElement>
                  </span>
                </>
              );
            },
          },
          {
            name: 'Level',
            key: 'userRank',
            render: (item) => (
              <img
                className='level'
                src={`/assets/images/rank/rank_${item?.userRank}.png`}
                alt=''
              />
            ),
          },
          {
            name: 'Type',
            key: 'transactionTypeName',
          },
          {
            name: 'Amount',
            key: 'userAmount',
            render: (item) => {
              const value = +item.userAmount;
              return value
                ? NumberUtils.toFormatNumber(
                    +item.userAmount,
                    +getEnv('NUMBER_DECIMAL_DISPLAY'),
                  )
                : '0.00000000';
            },
          },
          {
            name: 'User (user-generated)',
            key: 'userGeneratedEmail',
            render: (item) => {
              return (
                <>
                  <span>{item?.userGeneratedFirstName}</span>
                  <br />
                  <span>
                    <CopyToClipboardElement
                      text={item?.userGeneratedEmail}
                      onCopy={() => {
                        CreateAlert({
                          message: translate('Copied'),
                          type: 'success',
                        });
                      }}
                    >
                      <div className='value'>
                        <span className='email'>
                          {item?.userGeneratedEmail}
                        </span>
                        <span className='icon'>
                          <Icon.Copy />
                        </span>
                      </div>
                    </CopyToClipboardElement>
                  </span>
                </>
              );
            },
          },
          {
            name: 'Level (user-generated)',
            key: 'userGeneratedRank',
            render: (item) => (
              <img
                className='level'
                src={`/assets/images/rank/rank_${item?.userGeneratedRank}.png`}
                alt=''
              />
            ),
          },
          {
            name: 'Personal Volume (user-generated)',
            key: 'userGeneratedVolume',
            render: (item) => {
              const value = +item.userGeneratedVolume;
              return value
                ? NumberUtils.toFormatNumber(
                    +item.userGeneratedVolume,
                    +getEnv('NUMBER_DECIMAL_DISPLAY'),
                  )
                : '0.00000000';
            },
          },
          {
            name: 'Created',
            key: 'created',
            className: 'created',
            render: (item) => {
              const date = new Date(item.created);
              return (
                <span>
                  {date.toLocaleDateString(getLocaleKey())}{' '}
                  {date.toLocaleTimeString(getLocaleKey())}
                </span>
              );
            },
          },
        ]}
        fetchData={async (state) => {
          const params = { ...state };
          setParams(params);
          if (params['fromDate'])
            params['fromDate'] = new Date(params['fromDate']);
          if (params['toDate']) params['toDate'] = new Date(params['toDate']);

          return AdminService.getListCommissionHistoryFranchise({
            page: params.pageNumber,
            numberOfTransactionsPerPage: params.limit,
            ...params,
          }).then((res) => {
            setCurrentData(res);
            setTotalAmount(res?.totalAmount);
            return res;
          });
        }}
      />
    </div>
  );
});

export default PageFranchiseCommissionHistory;
